import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const KitchenHoursIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.3 8.5C15.3 4.74446 12.2556 1.69999 8.5 1.69999C4.74446 1.69999 1.69999 4.74446 1.69999 8.5C1.69999 12.2556 4.74446 15.3 8.5 15.3C12.2556 15.3 15.3 12.2556 15.3 8.5ZM7.65001 4.24999C7.65001 3.78055 8.03056 3.4 8.5 3.4C8.96944 3.4 9.34999 3.78055 9.34999 4.24999V6.99874L10.1877 6.49613C10.5902 6.25461 11.1123 6.38515 11.3539 6.78769C11.5954 7.19023 11.4649 7.71234 11.0623 7.95387L8.93731 9.22887C8.67472 9.38642 8.3477 9.39055 8.08122 9.23968C7.81473 9.08879 7.65001 8.80623 7.65001 8.5V4.24999ZM17 8.5C17 13.1945 13.1945 17 8.5 17C3.80558 17 0 13.1945 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1945 0 17 3.80558 17 8.5Z"
      fill="currentColor"
    />
  </svg>
)

export default KitchenHoursIcon
